module.exports = __webpack_public_path__ + "img/商城全国电信流量卡.e062b9e9.png";